import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuthContext } from "contexts/AuthContext";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { getFunction, saveFunction } from "actions/workflows";
import Input from "components/Elements/Input";
import ErrorField from "components/ErrorField";
import CodeMirror from "@uiw/react-codemirror";
import { json } from "@codemirror/lang-json";
import { python } from "@codemirror/lang-python";
import { EditorView } from "@codemirror/view";

const Function = () => {
  const navigate = useNavigate();
  const { function_id } = useParams();
  const { activeUser } = useAuthContext();
  console.log("FUNCTION ID 2: ", function_id);
  const { funct, saving } = useSelector((state) => state.workflows);
  console.log("FUNCT: ", funct);
  const [localFunction, setLocalFunction] = useState(funct);
  const [formErrors, setFormErrors] = useState({});
  const dispatch = useDispatch();
  useEffect(() => {
    console.log("GET FUNCTION");
    dispatch(getFunction(function_id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    //dispatch(clearFunction());
    console.log("funct: ", funct);
    setLocalFunction(funct);

    // eslint-disable-next-line
  }, [funct]);

  console.log("function ID: ", function_id);
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("STATE: ", location);
  }, [location]);

  const handleChange = ({ target }) => {
    const a = { ...localFunction };
    a[target.name] = target.value;
    setLocalFunction(a);
  };

  const handleCodeChange = (name, code) => {
    const a = { ...localFunction };
    a[name] = code;
    setLocalFunction(a);
  };

  const validateFields = () => {
    setFormErrors({});
    const errors = {};

    console.log("function: ", localFunction);
    const nameValid = localFunction.name && localFunction.name.length > 0;

    errors.name = nameValid ? "" : " is required";

    console.log("errors: ", errors);
    setFormErrors(errors);

    return nameValid;
  };

  const save = () => {
    console.log("save function: ", localFunction);
    if (validateFields()) {
      dispatch(saveFunction(localFunction));
    }
  };

  return (
    <div>
      <div>
        <div
          className="text-blueGray-500 text-xs font-bold uppercase"
          onClick={() => {
            navigate("/admin/functions");
          }}
          style={{ cursor: "pointer" }}
        >
          <i className="fa fa-arrow-left" /> Back to Functions
                </div>{" "}
      </div>
      <h3 className="font-bold text-lg text-blueGray-700">
        {localFunction ? localFunction.name : "Function"}
      </h3>
      <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
        <label>ID</label>
        <Input
          label="ID"
          placeholder="ID"
          name="id"
          value={localFunction ? localFunction.id : ""}
          disabled
        />
        <label>Public ID</label>
        <Input
          label="Public ID"
          placeholder="Public ID"
          name="public_id"
          value={localFunction ? localFunction.public_id : ""}
          disabled
        />
        <label>
          Name <ErrorField>{formErrors.name}</ErrorField>
        </label>
        <Input
          label="Name"
          placeholder="Name"
          name="name"
          value={localFunction ? localFunction.name : ""}
          onChange={handleChange}
        />
        <label>
          Description <ErrorField>{formErrors.description}</ErrorField>
        </label>
        <Input
          type="textarea"
          label="Description"
          placeholder="Description"
          name="description"
          value={
            localFunction && localFunction.description
              ? localFunction.description
              : ""
          }
          onChange={handleChange}
        />
        <label>
          Parameters <ErrorField>{formErrors.parameters}</ErrorField>
          <span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://platform.openai.com/docs/guides/gpt/function-calling"
            >
              (Docs)
                    </a>
          </span>
        </label>
        <CodeMirror
          extensions={[json(), EditorView.lineWrapping]}
          label="Parameters"
          name="parameters"
          value={
            localFunction && localFunction.parameters
              ? localFunction.parameters
              : ""
          }
          onChange={(code) => handleCodeChange("parameters", code)}
          style={{ width: "calc(100vw - 350px)" }}
        />
        <label>
          Output Parameters (JSON)
                  <ErrorField>{formErrors.output_params}</ErrorField>
        </label>
        <CodeMirror
          extensions={[json(), EditorView.lineWrapping]}
          label="Output Parameters"
          name="output_params"
          value={
            localFunction && localFunction.output_params
              ? localFunction.output_params
              : ""
          }
          onChange={(code) => handleCodeChange("output_params", code)}
          style={{ width: "calc(100vw - 350px)" }}
        />
        <label>
          Code <ErrorField>{formErrors.code}</ErrorField>
        </label>
        <CodeMirror
          extensions={[python(), EditorView.lineWrapping]}
          label="Code"
          placeholder="Python Code"
          name="code"
          value={
            localFunction && localFunction.code
              ? localFunction.code
              : ""
          }
          onChange={(code) => handleCodeChange("code", code)}
          style={{ width: "calc(100vw - 350px)" }}
        />
      </div>
      {activeUser && activeUser.user_type === "admin" && (
        <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
          <button
            className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="button"
            onClick={save}
            disabled={saving}
          >
            {saving ? (
              <>
                <i className="fas fa-circle-notch fa-spin"></i>{" "}
                        Saving...
                      </>
            ) : (
              <>Save Changes</>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default Function;
